// @flow

import type { Action } from '../store.type';

export const LIST_FILTER_TREE_REQUEST = 'LIST_FILTER_TREE_REQUEST';
type LIST_FILTER_TREE_REQUEST_TYPE = 'LIST_FILTER_TREE_REQUEST';

export const LIST_FILTER_TREE_SUCCESS = 'LIST_FILTER_TREE_SUCCESS';
type LIST_FILTER_TREE_SUCCESS_TYPE = 'LIST_FILTER_TREE_SUCCESS';

export const LIST_FILTER_TREE_FAILURE = 'LIST_FILTER_TREE_FAILURE';
type LIST_FILTER_TREE_FAILURE_TYPE = 'LIST_FILTER_TREE_FAILURE';

type ListFilterTreeSuccess = {
  data: Object
};

type ListFilterTreeFailure = {
  error: any
};

type ListFilterTreeRequestAction = Action<LIST_FILTER_TREE_REQUEST_TYPE, null>;

type ListFilterTreeSuccessAction = Action<LIST_FILTER_TREE_SUCCESS_TYPE, ListFilterTreeSuccess>;

type ListFilterTreeFailureAction = Action<LIST_FILTER_TREE_FAILURE_TYPE, ListFilterTreeFailure>;

type FilterTreeInfoType = {
  filterId: string,
  name: string,
  isDefault: boolean,
  isDefaultSearch: boolean,
  status: string
};

export type ListFilterTreeState = {
  loading: boolean,
  searching: boolean,
  success: boolean,
  error: any,
  total: number,
  defaultFilterTrees: Array<FilterTreeInfoType>,
  searchFilterTrees: Array<FilterTreeInfoType>,
  customtFilterTrees: Array<FilterTreeInfoType>
};

export type ListFilterTreeAction =
  | ListFilterTreeRequestAction
  | ListFilterTreeSuccessAction
  | ListFilterTreeFailureAction
  | ListFilterTreeInfoRequestAction
  | ListFilterTreeInfoSuccessAction
  | ListFilterTreeInfoFailureAction;

// Search filter trees
export const SEARCH_FILTER_TREE_REQUEST = 'SEARCH_FILTER_TREE_REQUEST';
type SEARCH_FILTER_TREE_REQUEST_TYPE = 'SEARCH_FILTER_TREE_REQUEST';

export const SEARCH_FILTER_TREE_SUCCESS = 'SEARCH_FILTER_TREE_SUCCESS';
type SEARCH_FILTER_TREE_SUCCESS_TYPE = 'SEARCH_FILTER_TREE_SUCCESS';

export const SEARCH_FILTER_TREE_FAILURE = 'SEARCH_FILTER_TREE_FAILURE';
type SEARCH_FILTER_TREE_FAILURE_TYPE = 'SEARCH_FILTER_TREE_FAILURE';

type SearchFilterTreeSuccess = {
  data: Object
};

type SearchFilterTreeFailure = {
  error: any
};

type SearchFilterTreeRequestAction = Action<SEARCH_FILTER_TREE_REQUEST_TYPE, null>;

type SearchFilterTreeSuccessAction = Action<
  SEARCH_FILTER_TREE_SUCCESS_TYPE,
  SearchFilterTreeSuccess
>;

type SearchFilterTreeFailureAction = Action<
  SEARCH_FILTER_TREE_FAILURE_TYPE,
  SearchFilterTreeFailure
>;

export type SearchFilterTreeAction =
  | SearchFilterTreeRequestAction
  | SearchFilterTreeSuccessAction
  | SearchFilterTreeFailureAction;

// Change status
export const CHANGE_FILTER_TREE_STATUS_REQUEST = 'CHANGE_FILTER_TREE_STATUS_REQUEST';
type CHANGE_FILTER_TREE_STATUS_REQUEST_TYPE = 'CHANGE_FILTER_TREE_STATUS_REQUEST';

export const CHANGE_FILTER_TREE_STATUS_SUCCESS = 'CHANGE_FILTER_TREE_STATUS_SUCCESS';
type CHANGE_FILTER_TREE_STATUS_SUCCESS_TYPE = 'CHANGE_FILTER_TREE_STATUS_SUCCESS';

export const CHANGE_FILTER_TREE_STATUS_FAILURE = 'CHANGE_FILTER_TREE_STATUS_FAILURE';
type CHANGE_FILTER_TREE_STATUS_FAILURE_TYPE = 'CHANGE_FILTER_TREE_STATUS_FAILURE';

type ChangeFilterTreeStatusSuccess = {
  data: Object
};

type ChangeFilterTreeStatusFailure = {
  error: any
};

type ChangeFilterTreeStatusRequestAction = Action<CHANGE_FILTER_TREE_STATUS_REQUEST_TYPE, null>;

type ChangeFilterTreeStatusSuccessAction = Action<
  CHANGE_FILTER_TREE_STATUS_SUCCESS_TYPE,
  ChangeFilterTreeStatusSuccess
>;

type ChangeFilterTreeStatusFailureAction = Action<
  CHANGE_FILTER_TREE_STATUS_FAILURE_TYPE,
  ChangeFilterTreeStatusFailure
>;

export type ChangeFilterTreeStatusAction =
  | ChangeFilterTreeStatusRequestAction
  | ChangeFilterTreeStatusSuccessAction
  | ChangeFilterTreeStatusFailureAction;

// Clone filter tree
export const CLONE_FILTER_TREE_REQUEST = 'CLONE_FILTER_TREE_REQUEST';
type CLONE_FILTER_TREE_REQUEST_TYPE = 'CLONE_FILTER_TREE_REQUEST';

export const CLONE_FILTER_TREE_SUCCESS = 'CLONE_FILTER_TREE_SUCCESS';
type CLONE_FILTER_TREE_SUCCESS_TYPE = 'CLONE_FILTER_TREE_SUCCESS';

export const CLONE_FILTER_TREE_FAILURE = 'CLONE_FILTER_TREE_FAILURE';
type CLONE_FILTER_TREE_FAILURE_TYPE = 'CLONE_FILTER_TREE_FAILURE';

type CloneFilterTreeSuccess = {
  data: Object
};

type CloneFilterTreeFailure = {
  error: any
};

type CloneFilterTreeRequestAction = Action<CLONE_FILTER_TREE_REQUEST_TYPE, null>;

type CloneFilterTreeSuccessAction = Action<CLONE_FILTER_TREE_SUCCESS_TYPE, CloneFilterTreeSuccess>;

type CloneFilterTreeFailureAction = Action<CLONE_FILTER_TREE_FAILURE_TYPE, CloneFilterTreeFailure>;

export type CloneFilterTreeAction =
  | CloneFilterTreeRequestAction
  | CloneFilterTreeSuccessAction
  | CloneFilterTreeFailureAction;

// Remove filter tree
export const REMOVE_FILTER_TREE_REQUEST = 'REMOVE_FILTER_TREE_REQUEST';
type REMOVE_FILTER_TREE_REQUEST_TYPE = 'REMOVE_FILTER_TREE_REQUEST';

export const REMOVE_FILTER_TREE_SUCCESS = 'REMOVE_FILTER_TREE_SUCCESS';
type REMOVE_FILTER_TREE_SUCCESS_TYPE = 'REMOVE_FILTER_TREE_SUCCESS';

export const REMOVE_FILTER_TREE_FAILURE = 'REMOVE_FILTER_TREE_FAILURE';
type REMOVE_FILTER_TREE_FAILURE_TYPE = 'REMOVE_FILTER_TREE_FAILURE';

type RemoveFilterTreeSuccess = {
  data: Object
};

type RemoveFilterTreeFailure = {
  error: any
};

type RemoveFilterTreeRequestAction = Action<REMOVE_FILTER_TREE_REQUEST_TYPE, null>;

type RemoveFilterTreeSuccessAction = Action<
  REMOVE_FILTER_TREE_SUCCESS_TYPE,
  RemoveFilterTreeSuccess
>;

type RemoveFilterTreeFailureAction = Action<
  REMOVE_FILTER_TREE_FAILURE_TYPE,
  RemoveFilterTreeFailure
>;

export type RemoveFilterTreeAction =
  | RemoveFilterTreeRequestAction
  | RemoveFilterTreeSuccessAction
  | RemoveFilterTreeFailureAction;

export const LIST_FILTER_TREE_INFO_REQUEST = 'LIST_FILTER_TREE_INFO_REQUEST';
type LIST_FILTER_TREE_INFO_REQUEST_TYPE = 'LIST_FILTER_TREE_INFO_REQUEST';

export const LIST_FILTER_TREE_INFO_SUCCESS = 'LIST_FILTER_TREE_INFO_SUCCESS';
type LIST_FILTER_TREE_INFO_SUCCESS_TYPE = 'LIST_FILTER_TREE_INFO_SUCCESS';

export const LIST_FILTER_TREE_INFO_FAILURE = 'LIST_FILTER_TREE_INFO_FAILURE';
type LIST_FILTER_TREE_INFO_FAILURE_TYPE = 'LIST_FILTER_TREE_INFO_FAILURE';

type ListFilterTreeInfoSuccess = {
  data: Object
};

type ListFilterTreeInfoFailure = {
  error: any
};

type ListFilterTreeInfoRequestAction = Action<LIST_FILTER_TREE_INFO_REQUEST_TYPE, null>;

type ListFilterTreeInfoSuccessAction = Action<LIST_FILTER_TREE_INFO_SUCCESS_TYPE, ListFilterTreeInfoSuccess>;

type ListFilterTreeInfoFailureAction = Action<LIST_FILTER_TREE_INFO_FAILURE_TYPE, ListFilterTreeInfoFailure>;
